import StrikethroughSRoundedIcon from '@material-ui/icons/StrikethroughSRounded';
import { RTE_TOOLBAR_MARKS } from '../../constants/RTEToolbar.marks';
import { MarkToolButton } from '../MarkToolButton/MarkToolButton';

export const StrikeThroughMarkTool = () => {
  return (
    <MarkToolButton markFormat={RTE_TOOLBAR_MARKS.strikethrough}>
      <StrikethroughSRoundedIcon />
    </MarkToolButton>
  );
};
